var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinnerDining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20,
    y: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,14.5h14c0-2.49-2.01-4.5-4.5-4.5c-2.03,0-3.72,1.35-4.28,3.19C7.86,12.92,7.45,12.73,7,12.61V8h3V6h7V5h-7V3H3v1h1v1H3 v1h1v1H3v1h1v5.26C3.58,13.59,3.23,14.01,3,14.5z M8.5,7H7V6h1.5V7z M8.5,4v1H7V4H8.5z M5,4h1v1H5V4z M5,6h1v1H5V6z M5,8h1v4.51 c-0.35,0.02-0.68,0.08-1,0.19V8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2,15.5 3.5,17 16.5,17 18,15.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinnerDining);
export default __webpack_public_path__ + "static/media/dinner_dining.9d3fe28cb1e12a05589f1a9dba181d9d.svg";
export { ForwardRef as ReactComponent };